import { mapState, mapGetters, mapActions } from "vuex";

export const bannerComputed = {
  ...mapState("banner", {
    storeBanner: (state) => state.storeBanner
  })
};

export const webHookComputed = {
  ...mapState("webhook", {
    storeSelect: (state) => state.storeSelect,
    keyAuth: (state) => state.keyAuth
  }),
  ...mapGetters("webhook", ["PermissionFlag"])
};

export const documentComputed = {
  ...mapState("document", {
    selectStore: (state) => state.selectStore
  })
};

export const authComputed = {
  ...mapState("auth", {
    currentUser: (state) => state.currentUser,
    userCurrent: (state) => state.userCurrent,
    accessLevel: (state) => state.accessLevel,
    version: (state) => state.version,
    tabStatusTest: (state) => state.tabStatusTest,
    storeRegister:(state) => state.storeRegister
  }),
  ...mapGetters("auth", ["loggedIn", "dataConfirm"])
};

export const userComputed = {
  ...mapState("users", {
    userProfile: (state) => state.userProfile,
    keyAuth: (state) => state.keyAuth
  }),
  ...mapGetters("users", ["otpDelete", "PermissionFlag"])
};

export const pickupComputed = {
  ...mapState("pickup", {
    userProfile: (state) => state.userProfile,
    keyAuth: (state) => state.keyAuth
  }),
  ...mapGetters("pickup", ["PermissionFlag"])
};

export const walletComputed = {
  ...mapGetters("wallet", ["isTransaction"])
};

export const topupComputed = {
  ...mapState("topup", {
    banks: (state) => state.bank,
    topupValue: (state) => state.topup,
    topupPackage: (state) => state.topup_package,
    topupReport: (state) => state.topupReport,
    codReport: (state) => state.codReport,
    keyAuth: (state) => state.keyAuth
  }),
  ...mapGetters("topup", ["PermissionFlag"])
};

export const partnerComputed = {
  ...mapState("partner", {
    partnerList: (state) => state.partnerList,
    partnerListOption: (state) => state.partnerListOption
  })
};

export const reportComputed = {
  ...mapState("report", {
    reportPickup: (state) => state.reportPickup,
    reportTranAffiliate: (state) => state.reportTranAffiliate,
    storeSelectApproveCod: (state) => state.storeSelectApproveCod,
    idCod: (state) => state.idCod,
    keyAuth: (state) => state.keyAuth
  }),
  ...mapGetters("report", ["PermissionFlag"])
};

export const addrComputed = {
  ...mapGetters("address", [
    "isAddressList",
    "getAddr",
    "getPickupConfig",
    "isOrderAddressPickup"
  ])
};

export const layoutComputed = {
  ...mapState("layout", {
    layoutType: (state) => state.layoutType,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    loader: (state) => state.loader
  })
};

export const employeeComputed = {
  ...mapState("employee", {
    employeeList: (state) => state.employeeList,
    keyAuth: (state) => state.keyAuth
  }),
  ...mapGetters("employee", ["PermissionFlag"])
};

export const orderComputed = {
  ...mapState("order", {
    idOrder: (state) => state.idOrder,
    orderMarkUp: (state) => state.orderMarkUp,
    orderCommission: (state) => state.orderCommission,
    statusModal: (state) => state.statusModal,
    OrderReport: (state) => state.OrderReport,
    OrderReportGraph: (state) => state.OrderReportGraph,
    logistic: (state) => state.logistic,
    logisticSummery: (state) => state.logisticSummery,
    ordermulti: (state) => state.ordermulti,
    claimorder: (state) => state.claimorder,
    storeSelectPickup: (state) => state.storeSelectPickup,

    logisticList: (state) => state.logistic,
    logisticSummery: (state) => state.logisticSummery,
    ordermulti: (state) => state.ordermulti,
    claimorder: (state) => state.claimorder,
    keyAuth: (state) => state.keyAuth
  }),
  ...mapGetters("order", ["PermissionFlag"])
};

export const creditComputed = {
  ...mapState("credit", {
    selectStore: (state) => state.selectStore,
    storeByid: (state) => state.storeByid,
    storeOtherFeeSelect: (state) => state.storeOtherFeeSelect,
    keyAuth: (state) => state.keyAuth,
    
  }),
  ...mapGetters("credit", ["PermissionFlagCredit"])
};

export const webHookMethods = mapActions("webhook", [
  "generateToken",
  "getListWebHook",
  "getListWebHookById",
  "createWebHook",
  "updateWebHook",
  "deleteWebHook"
]);

export const documentMethods = mapActions("document", [
  "getTaxInvoice",
  "getTaxInvoiceByid",
  "getTaxInvoiceByidDetail",
  "createTaxinvoice",
  "texInvoiceGetLink",
  "getPrintTaxinvoice"
]);

export const addrMethods = mapActions("address", [
  "fetchAddressList",
  "addNewAddress",
  "addNewAddressIncreateOrder",
  "deleteAddress",
  "editAddress",
  "fetchPickupConfig",
  "editPickupConfig",
  "addPickupConfig",
  "fetchOrderPickupAddress",
  "editOrderPickupAddress",
  "loadAddress",
  "saveAddress",
  "updateAddress",
  "deleteAddress",
  "pickupPointConfigs",
  "getPickupPointConfigs"
]);

export const authMethods = mapActions("auth", [
  "isPageRefreshed",
  "logIn",
  "logInGoogle",
  "loginNormal",
  "logOut",
  "register",
  "signUp",
  "resetPassword",
  "requestOtp",
  "verifiedOtp",
  "checkDuplicate",
  "checkInviteKey",
  "checkAffiliateKey",
  "validInviteKey",
  "validAffiliateKey",
  "acceptInvite",
  "acceptAffiliate",
  "loginSystem",
  "getAccountShop",
  "selectShop",
  "InitPermission",
  "register",
  "reSendOtp",
  "confirmOtp",
  "validate",
  "checkKeyInvite",
  "useKeyInvite",
  "forgetSendEmailOTP",
  "forgetVerifyOtp",
  "confirmChangePassword",
  "lotOutAPI",
  "sendSupportRequest",
  "getAccessLevel",
  "getGraphParcelProvince",
  "getGraphWeightSize"
]);

export const userMethods = mapActions("users", [
  "fetchProfile",
  "updateUserProfile",
  "updatePersonal",
  "verifyCard",
  "verifyBank",
  "proFile",
  "uploadProfile",
  "updateProfile",
  "getOtpForDelete",
  "deleteAccount",
  "updateProfileMultiple",
  "updatePeolpleNormal",
  "updateJuristicVerify",
  "updateCod",
  "verifyEmail",
  "verifyEmailOtp",
  "getNotification",
  "readNotification",
  "updateConfigNoti"
]);

export const layoutMethods = mapActions("layout", [
  "changeLayoutType",
  "changeLayoutWidth",
  "changeLeftSidebarType",
  "changeTopbar",
  "changeLoaderValue"
]);

export const topupMethods = mapActions("topup", [
  "fetchTopupData",
  "topup",
  "fetchReport",
  "fetchReportTransection",
  "loadPrice",
  "bankLoad",
  "topUpMoney"
]);

export const authFackMethods = mapActions("authfack", [
  "login",
  "registeruser",
  "logout"
]);

export const notificationMethods = mapActions("notification", [
  "success",
  "error",
  "clear"
]);

export const walletMethods = mapActions("wallet", ["fetchTransaction"]);

export const employeeMethods = mapActions("employee", [
  "fetchEmplyeeList",
  "generateKey",
  "editUser",
  "addEmployee",
  "getEmployee",
  "setUpdate",
  "deleteEmployee"
]);

export const orderMethods = mapActions("order", [
  // "logisticCalculate", "caculateSummary", "createOrder", "cancelOrder", "GetClaimOrder"
  "fetchAddressSender",
  "logisticCalculate",
  "caculateSummary",
  "createOrderByadmin",
  "fetchReportOrder",
  "fetchReportOrderDetail",
  "CalculateCod",
  "CalculateCost",
  "CalculateOrder",
  "fetchReportOrderGraph",
  "cancelOrderByadmin",
  "GetClaimOrder",
  "CreateClaimOrder",
  "loadSummary",
  "loadCommissionOrder",
  "loadCommissionOrderSearch",
  "loadAccount",
  "loadTimeline",
  "loadApiLog",
  "LoadOrderMarkUpAll",
  "getOrderMarkupByPartnerAwbNo",
  "LoadOrderMarkUpSelect",
  "createOrder",
  "LoadTransection",
  "GetOrderMarkup",
  "GetPickupAddresss",
  "LoadPickupTransport",
  "LoadReceiveAddress",
  "LoadEstimateShippingPrice",
  "CreateOrderNew",
  "GetBoxpackage",
  "loadTimelineOrder",
  "LoadTimeLinePopupstepTwo",
  "addOrderSave",
  "loadClaimType",
  "loadWelletTransection",
  "loadApiCommission",
  "cancelOrder",

  "uploadfile",
  "getPartnerAll",
  "getPartnerList",
  "updatePickup",
  "getPickupOrderById",
  "getPickupSummary",
  "getPickupOrder",
  // "getCodOrder",
  // "getCodOrderSummary",
  // "getCodOrderSummaryMoney",
  // "exportOrderCodFile",
  "CreateOrderMultiple",
  "exportExcelShipmentOrder",
  "dataGraph",
  "loadSummaryDefault",
  "getAccount",
  "printSentTo",
  "getParcelHandoverDocument",
  "DeleteAccount",
  "createPickupOrder",
  "getPickupOrderByIdToken",
  "getAccountProfile",
  "getPickupOrderByid",
  "getDocumentCreditNote",
  "getProductOnOrder",
  "getPriceInsurance",
  "getHistoryInsuranceOrder"

]);

export const partnerMethods = mapActions("partner", ["getPartnerOption"]);

export const reportMethods = mapActions("report", [
  "getReportPickup",
  "getReportAffiliate",
  "loadRefillWallet",
  "loadTransection",
  "loadReportCod",
  "loadReportPickup",
  "loadReportAffiliate",
  "loadTransectionCOD",
  "generateKeyReport",
  "getKeyConnect",
  "getCodApprove",
  "getCodApproveByid",
  "getParceShipmentCod",
  "exportCodApproval",
  "getCodOrder",
  "getCodOrderSummary",
  "getCodOrderSummaryMoney",
  "exportOrderCodFile",
  "getHistoryInsurance"
]);

export const creditMethods = mapActions("credit", [
  "getCredit",
  "getCreditByid",
  "getInvoiceShipmentOrder",
  "cancelCredit",
  "approveCredit",
  "exportExcelApi",
  "getDebt",
  "getDebtByid",
  "getOrderExportExcepApi",
  "getBank",
  "approveCreditCreate",
  "creditNoteExportExcel",
  "creditNoteByid",
  "createCreditNoteDown",
  "getCheckCreditOrder",
  "getCheckCreditSummary",
  "getOtherFeeAll",
  "getOtherFeeSummary",
  "createOtherFee",
  "approveMultiService",
  "getOtherFeeByid",
  "approveOtherByid",
  "deleteOtherFee",
  "updateOtherFee",
  "createDisplayCredit",
  "creditNoteGetLink"
]);

export const bannerMethods = mapActions("banner", ["getBanner"]);
